export default "__VITE_ASSET__DIyGZWuY__"